import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import JikeYixia from './pages/JikeYixia';
import TailscaleDoctor from './pages/TailscaleDoctor';
import TuttiHelper from './pages/TuttiHelper';
import TuttiHelperStory from './pages/TuttiHelperStory';
import TuttiHelperPrivacy from './pages/TuttiHelperPrivacy';
import TuttiHelperChangelog from './pages/TuttiHelperChangelog';
import TuttiHelperAccount from './pages/TuttiHelperAccount';
import JikeYixiaPrivacy from './pages/JikeYixiaPrivacy';
import PrivacyIndex from './pages/PrivacyIndex';
import ZipWithPasswordPrivacy from './pages/ZipWithPasswordPrivacy';
import RetroNoisePrivacy from './pages/RetroNoisePrivacy';
import NextHoliPrivacy from './pages/NextHoliPrivacy';
import CCRemotePrivacy from './pages/CCRemotePrivacy';
import QuoteCamPrivacy from './pages/QuoteCamPrivacy';
import CompressToolsPrivacy from './pages/CompressToolsPrivacy';
import CCRemoteGuide from './pages/CCRemoteGuide';
import CCRemoteGuideCN from './pages/CCRemoteGuideCN';
import Timeline from './pages/Timeline';
import Lab from './pages/Lab';
import LabProject from './pages/LabProject';
import Footer from './components/Footer';
import { analytics } from './firebase';
import './styles/App.css';
import './styles/privacy.css';
import './styles/timeline.css';

function App() {
  useEffect(() => {
    // Firebase Analytics is automatically initialized when imported
    if (analytics) {
      console.log('Firebase Analytics initialized');
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyIndex />} />
          <Route path="/jikeyixia" element={<JikeYixia />} />
          <Route path="/tailscale-doctor" element={<TailscaleDoctor />} />
          <Route path="/tutti-helper" element={<TuttiHelper />} />
          <Route path="/tutti-helper/story" element={<TuttiHelperStory />} />
          <Route path="/tutti-helper/privacy" element={<TuttiHelperPrivacy />} />
          <Route path="/tutti-helper/changelog" element={<TuttiHelperChangelog />} />
          <Route path="/tutti-helper/account" element={<TuttiHelperAccount key="public-account" />} />
          <Route path="/tutti-helper/test/account" element={<TuttiHelperAccount key="test-account" />} />
          <Route path="/jikeyixia/privacy" element={<JikeYixiaPrivacy />} />
          <Route path="/zipwithpassword/privacy" element={<ZipWithPasswordPrivacy />} />
          <Route path="/retronoise/privacy" element={<RetroNoisePrivacy />} />
          <Route path="/nextholi/privacy" element={<NextHoliPrivacy />} />
          <Route path="/ccremote/privacy" element={<CCRemotePrivacy />} />
          <Route path="/quotecam/privacy" element={<QuoteCamPrivacy />} />
          <Route path="/compresstools/privacy" element={<CompressToolsPrivacy />} />
          <Route path="/ccremote" element={<CCRemoteGuide />} />
          <Route path="/ccremote/cn" element={<CCRemoteGuideCN />} />
          <Route path="/timeline" element={<Timeline />} />
          <Route path="/lab" element={<Lab />} />
          <Route path="/lab/:projectId" element={<LabProject />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
